 /**
 * @name APP integration
 * @autor jaime.salazar@u-planner.com
 * @description
 * file index para modulo tablas de filtrado
 */

//importamos el file .route

import routing from './tablesint.route';

//importamos nuestros controladores

import tableintCtrl from './tableintCtrl';

//importamos nuestros services 

import tablesintServices from './tablesintServices';


//injectamos los controladores y servicios 
export default angular.module('app.tableint', [tablesintServices])
  .config(routing)
  .controller('tableintCtrl', tableintCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/integration-front/tablesint/index.js